import MailingSettingsButton from './MailingSettingsButton.component';

export default MailingSettingsButton;
